import { render } from "./Index.vue?vue&type=template&id=3c37b34f&scoped=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=3c37b34f&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3c37b34f"

export default script